export default [
  {
    path: '/home',
    icon: 'HomeIcon',
    component: () => import('@/views/home/index.vue'),
    meta: {
      layout: 'public',
    },
  },
  {
    path: '/todo',
    icon: 'HomeIcon',
    component: () => import('@/views/myApplication/todoData.vue'),
    meta: {
      layout: 'public',
    },
  },
  {
    path: '/message',
    icon: 'HomeIcon',
    component: () => import('@/views/myApplication/message.vue'),
    meta: {
      layout: 'public',
    },
  },
  {
    path: '/notifications',
    icon: 'HomeIcon',
    component: () => import('@/views/myApplication/notifications.vue'),
    meta: {
      layout: 'public',
    },
  },
  {
    path: '/apply/list/public',
    name: 'apply-list',
    icon: 'FileIcon',
    component: () => import('@/views/apply/list.vue'),
    meta: {
      layout: 'public',
    },
  },
  {
    path: '/apply/listByAuditor/public',
    name: 'apply-list',
    icon: 'FileIcon',
    component: () => import('@/views/apply/listByAuditor.vue'),
    meta: {
      pageTitle: 'Apply Data',
      layout: 'public',
    },
  },

  {
    path: '/worker/apply/list/public',
    name: 'apply-list',
    icon: 'FileIcon',
    component: () => import('@/views/worker/apply/list.vue'),
    meta: {
      layout: 'public',
    },
  },

  {
    path: '/worker/flow/leaveJob/index/public',
    name: 'apply-list',
    icon: 'FileIcon',
    component: () => import('@/views/worker/flow/leaveJob/index.vue'),
    meta: {
      layout: 'public',
    },
  },
  {
    path: '/worker/flow/transferDormitory/index/public',
    name: 'apply-list',
    icon: 'FileIcon',
    component: () => import('@/views/worker/flow/transferDormitory/index.vue'),
    meta: {
      layout: 'public',
    },
  },
  {
    path: '/worker/flow/workerForm/index/public',
    name: 'apply-list',
    icon: 'FileIcon',
    component: () => import('@/views/worker/flow/workerForm/index.vue'),
    meta: {
      layout: 'public',
    },
  },
  {
    path: '/worker/flow/course/index/public',
    name: 'apply-list',
    icon: 'FileIcon',
    component: () => import('@/views/worker/flow/course/index.vue'),
    meta: {
      layout: 'public',
    },
  },
  {
    path: '/worker/flow/passportApplication/index/public',
    name: 'apply-list',
    icon: 'FileIcon',
    component: () => import('@/views/worker/flow/passportApplication/index.vue'),
    meta: {
      layout: 'public',
    },
  },
  {
    path: '/worker/flow/courseApplication/index/public',
    name: 'apply-list',
    icon: 'FileIcon',
    component: () => import('@/views/worker/flow/courseApplication/index.vue'),
    meta: {
      layout: 'public',
    },
  },
  {
    path: '/worker/flow/leave/index/public',
    name: 'apply-list',
    icon: 'FileIcon',
    component: () => import('@/views/worker/flow/leave/index.vue'),
    meta: {
      layout: 'public',
    },
  },
  {
    path: '/worker/flow/turnSiteApply/index/public',
    name: 'apply-list',
    icon: 'FileIcon',
    component: () => import('@/views/worker/flow/turnSiteApply/index.vue'),
    meta: {
      layout: 'public',
    },
  },
  {
    path: '/staff/vacation/leaveCalendar/public',
    name: 'apply-list',
    icon: 'FileIcon',
    component: () => import('@/views/staff/vacation/leaveCalendar.vue'),
    meta: {
      layout: 'public',
    },
  },
  {
    path: '/sendRecord',
    icon: 'HomeIcon',
    component: () => import('@/views/myApplication/submitData.vue'),
    meta: {
      layout: 'public',
    },
  },
  {
    path: '/approvalRecord',
    icon: 'HomeIcon',
    component: () => import('@/views/myApplication/approvalData.vue'),
    meta: {
      layout: 'public',
    },
  },
]
